module.exports = __webpack_public_path__ + "media/images/flags/im-4fd71378d7ec727648fafeea77418517.svg";